import { render, staticRenderFns } from "./Historial-cliente.vue?vue&type=template&id=5bf366e0"
import script from "./Historial-cliente.vue?vue&type=script&lang=js"
export * from "./Historial-cliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports